module.exports = __webpack_public_path__ + "img/ocbcpao_logo.199b9aeb.png";